import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzListModule } from "ng-zorro-antd/list";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzIconModule, NZ_ICONS } from "ng-zorro-antd/icon";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzImageModule } from "ng-zorro-antd/image";
import { NzTimelineModule } from "ng-zorro-antd/timeline";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";

import * as AllIcons from "@ant-design/icons-angular/icons";
import { IconDefinition } from "@ant-design/icons-angular";
import { NzTypographyModule } from "ng-zorro-antd/typography";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { BooleanNamePipe } from "../pipes/boolean-name.pipe";
import { AccountTypeNamePipe } from "../pipes/account-type-name.pipe";

import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzMessageModule } from "ng-zorro-antd/message";

import { NzStatisticModule } from "ng-zorro-antd/statistic";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';

const nzModules = [
  NzTypographyModule,
  NzTimelineModule,
  NzStatisticModule,
  NzEmptyModule,
  NzImageModule,
  NzSkeletonModule,
  NzPaginationModule,
  NzCheckboxModule,
  NzBadgeModule,
  NzCollapseModule,
  NzPopoverModule,
  NzTagModule,
  NzFormModule,
  NzListModule,
  NzDescriptionsModule,
  NzInputModule,
  NzButtonModule,
  NzLayoutModule,
  NzUploadModule,
  NzSliderModule,
  NzMenuModule,
  NzDropDownModule,
  NzCardModule,
  NzTableModule,
  NzDividerModule,
  NzResultModule,
  NzSpinModule,
  NzModalModule,
  NzSwitchModule,
  NzSelectModule,
  NzToolTipModule,
  NzDatePickerModule,
  NzIconModule,
  NzMessageModule,
  NzSpaceModule,
];

const pipes: any[] = [BooleanNamePipe, AccountTypeNamePipe];

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons = Object.keys(antDesignIcons).map((key) => antDesignIcons[key]);

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, ...nzModules],
  declarations: [...pipes],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ...nzModules,
    ...pipes,
  ],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class SharedModule {}
